module.exports = __webpack_public_path__ + "static/images/cover.bdb978c.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cover.jpeg
// module id = 555
// module chunks = 0